import AppError from 'utils/appError';
import http from './httpService';

export interface SupportTicketRequest {
  subject: string;
  description: string;
  email: string;
}

export interface VisitorIdentificationContext {
  subscriptionType?: string;
  isInTrial?: string;
  language?: string;
}

export async function apiGetVisitorIdentificationToken(
  context: VisitorIdentificationContext,
  accessToken: string,
): Promise<string | undefined> {
  try {
    const ar = await http.post('/hubspot/user/token', context, http.getRequestConfig(accessToken));

    return ar.data?.valueString;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiCreateSupportTicket(
  ticket: SupportTicketRequest,
  files: File[],
  accessToken: string,
): Promise<void> {
  try {
    const formData = new FormData();
    formData.append('subject', ticket.subject);
    formData.append('description', ticket.description);
    formData.append('email', ticket.email);
    files.forEach((file) => formData.append('files', file, file.name));

    await http.post('/hubspot/support/ticket', formData, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetContactPhone(accessToken: string): Promise<string | undefined> {
  try {
    const ar = await http.get('/hubspot/contact/phone', http.getRequestConfig(accessToken));

    return ar.data?.valueString;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiUpdateContactPhone(phone: string, accessToken: string): Promise<void> {
  try {
    await http.put('/hubspot/contact/phone', { valueString: phone }, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
